import { render, staticRenderFns } from "./ProductsDetailsContainer.vue?vue&type=template&id=529f5ff2&scoped=true&"
import script from "./ProductsDetailsContainer.vue?vue&type=script&lang=ts&"
export * from "./ProductsDetailsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsDetailsContainer.vue?vue&type=style&index=0&id=529f5ff2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529f5ff2",
  null
  
)

export default component.exports